import type { CityConfig } from "../city-template/types";

export const grandHavenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Ottawa County Clerk", href: "https://www.miottawa.org/clerk", description: "Ottawa County Clerk — marriage license issuance" },
    { label: "Divorce Records — Ottawa County Clerk", href: "https://www.miottawa.org/clerk", description: "Ottawa County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Grand Haven",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "grand-haven",
  route: "/cities/grand-haven",
  title: "Emergency Passport Grand Haven, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Grand Haven, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Grand Haven, Spring Lake, Ferrysburg, Nunica, and all Ottawa County residents. Lake Michigan coastal coverage and Grand Haven State Park area. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Grand Haven, MI",
  heroSubtitle: "Grand Haven travelers — Ottawa County residents, Lake Michigan beachgoers, Coast Guard City families, and summer tourists — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Ottawa County and the West Michigan coast.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Grand%20Haven%20Michigan%20with%20iconic%20red%20lighthouse%2C%20Grand%20River%20channel%2C%20Lake%20Michigan%20shoreline%2C%20sandy%20beach%2C%20boats%20docked%20at%20harbor%2C%20green%20trees%2C%20clear%20summer%20sky%2C%20West%20Michigan%20coastal%20landscape%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography%20with%20warm%20tones&width=1800&height=700&seq=grand-haven-hero-001&orientation=landscape",
  heroImageAlt: "Grand Haven Michigan with iconic red lighthouse, Grand River channel, and Lake Michigan shoreline on a clear summer day",
  geoPosition: "43.0631;-86.2284",
  geoPlacename: "Grand Haven, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 175 miles east of Grand Haven — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Grand Haven", zips: "49417" },
    { name: "Spring Lake", zips: "49456" },
    { name: "Ferrysburg", zips: "49409" },
    { name: "Nunica", zips: "49448" },
    { name: "Coopersville", zips: "49404" },
    { name: "Holland", zips: "49422, 49423, 49424" },
    { name: "Zeeland", zips: "49464" },
    { name: "Muskegon", zips: "49440, 49441, 49442, 49443, 49444, 49445" },
    { name: "Norton Shores", zips: "49441, 49444" },
    { name: "Fruitport", zips: "49415" },
    { name: "Grand Rapids", zips: "49501, 49503, 49504, 49505, 49506, 49507, 49508, 49509, 49512, 49525, 49534, 49544" },
    { name: "Allendale", zips: "49401" },
    { name: "Jenison", zips: "49428" },
    { name: "Hudsonville", zips: "49426" },
    { name: "Grandville", zips: "49418" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "West Michigan Coast Expertise", desc: "Lake Michigan shore, Grand Haven State Park, Gerald R. Ford International Airport travel support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Ottawa County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Holland, MI", route: "/cities/holland" },
    { name: "Emergency passport services in Muskegon, MI", route: "/cities/muskegon" },
    { name: "Urgent passport services in Grand Rapids, MI", route: "/grand-rapids" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Grand Haven, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 175-mile drive or appointment wait. Grand Haven residents can ship from any UPS or FedEx in Ottawa County.",
  fpcOfficeDistance: "Serving Grand Haven, Spring Lake, Ferrysburg, Nunica, Coopersville, and all of Ottawa County and the West Michigan coast",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Grand Haven and the greater Ottawa County region. From the Grand Haven State Park beach to the Grand River channel, from the Coast Guard Festival to Spring Lake — we serve all of the West Michigan coast. The Detroit Passport Agency is approximately 175 miles east, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Grand Haven and all Ottawa County communities including Spring Lake, Ferrysburg, Nunica, Coopersville, Holland, Zeeland, and Jenison. We also serve Muskegon County coastal communities including Norton Shores, Fruitport, and Whitehall.",
  howItWorksIntro: "Most Grand Haven travelers complete everything online and ship documents overnight. No driving 175 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Grand Haven is a unique coastal community with heavy Lake Michigan tourism, Coast Guard City families, and summer festival travel. Here are the most common passport mistakes we see from Ottawa County travelers.",
  testimonialsIntro: "Grand Haven travelers — from Lake Michigan beachgoers to Coast Guard families to summer festival tourists — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Grand Haven, MI? Here are the most common ones we hear from Ottawa County and West Michigan coast travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for GRR Airport and West Michigan coast travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 175-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Grand Haven travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute GRR Airport flights, Coast Guard family emergencies, and Lake Michigan cruise travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "GRR Airport and West Michigan coast travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Grand Haven adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Ottawa County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Grand Haven residents and families — including Coast Guard families, summer tourists, and Ottawa County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Grand Haven residents who lost their passport before international travel or GRR Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Grand Haven-area families planning international vacations, beach trips, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Grand Haven and Ottawa County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Grand Haven MI", description: "Urgent passport processing for Grand Haven Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Grand Haven MI", description: "Fast passport renewal for Grand Haven Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Grand Haven MI", description: "New passport application services for Grand Haven Michigan residents applying for their first passport." },
    { name: "Child Passport Grand Haven MI", description: "Minor passport services for Grand Haven Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Grand Haven, MI",
      rating: 5,
      text: "Coast Guard transfer to Hawaii with 5 days notice and my passport was expired. Fast Passport Center got it renewed in 2 days. I shipped from the UPS Store on Robbins Road and had it back before my flight from GRR.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "James H.",
      location: "Spring Lake, MI",
      rating: 5,
      text: "Family cruise from Grand Haven to the Caribbean with 7 days notice. Fast Passport Center processed 4 passports in 3 days. They caught a photo error on one of the kids' applications that would have delayed us.",
      service: "Family Passport Package",
    },
    {
      name: "Lisa K.",
      location: "Ferrysburg, MI",
      rating: 5,
      text: "Business trip to Toronto and realized my passport was expired. Fast Passport Center got me a renewed passport in 3 days. Their courier service is a lifesaver for Grand Haven residents.",
      service: "Passport Renewal",
    },
    {
      name: "Michael R.",
      location: "Grand Haven, MI",
      rating: 5,
      text: "Lost my passport before a family trip to Europe. Fast Passport Center had a replacement in my hands in 48 hours. No driving to Detroit, no appointment wait. Truly the best service for Ottawa County.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "gh-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 175 miles east of Grand Haven — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "gh-2",
      name: "Grand Haven Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " " + "20 N. Harbor Dr",
      city: "Grand Haven",
      state: "MI",
      zip: "49417",
      phone: "(616) 842-6120",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Grand Haven — near the harbor and lighthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Grand Haven acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Grand Haven and the harbor area.",
      icon: "ri-mail-line",
    },
    {
      id: "gh-3",
      name: "Spring Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " " + "200 E. Savidge St",
      city: "Spring Lake",
      state: "MI",
      zip: "49456",
      phone: "(616) 842-2110",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Spring Lake — approximately 3 miles east of Grand Haven",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Spring Lake and eastern Grand Haven residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "gh-4",
      name: "Muskegon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " " + "801 4th St",
      city: "Muskegon",
      state: "MI",
      zip: "49440",
      phone: "(231) 726-4471",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Muskegon — approximately 15 miles north of Grand Haven",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Muskegon and northern Ottawa County residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "gh-5",
      name: "Holland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " " + "61 E. 8th St",
      city: "Holland",
      state: "MI",
      zip: "49423",
      phone: "(616) 396-2301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Holland — approximately 25 miles south of Grand Haven",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Holland and southern Ottawa County residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Ottawa County" },
    { feature: "GRR Airport & West Michigan Coast Expertise", agency: "No tailored advice", fpc: "Yes — Gerald R. Ford International Airport and coastal travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Grand Haven and Ottawa County travelers often discover passport issues right before Coast Guard transfers or summer beach trips. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some Grand Haven-area travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Ottawa County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Gerald R. Ford International Airport Flight Requirements",
      description: "Gerald R. Ford International Airport (GRR) in Grand Rapids has growing international flight options. Many Grand Haven travelers also use Chicago O'Hare or Detroit Metro. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Ottawa County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Grand Haven, Spring Lake, or Holland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 175-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ottawa County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Grand Haven, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Grand Haven, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 175 miles east. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Grand Haven?", a: "Fast Passport Center offers emergency passport processing in Grand Haven, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 175 miles east or take a day off work." },
    { q: "Do I need a passport for international flights from Gerald R. Ford International Airport?", a: "Yes. All international flights from Gerald R. Ford International Airport (GRR) in Grand Rapids require a passport book. GRR serves Grand Haven and all of West Michigan. While GRR has growing international options, many Grand Haven travelers also connect through Chicago O'Hare or Detroit Metro for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Grand Haven suburbs like Spring Lake or Ferrysburg?", a: "Absolutely. Fast Passport Center serves all of Ottawa County including Spring Lake, Ferrysburg, Nunica, Coopersville, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Grand Haven-area travelers use for international flights?", a: "Gerald R. Ford International Airport (GRR) in Grand Rapids is the primary airport for Grand Haven and West Michigan — approximately 30 miles northeast. GRR has growing domestic and international service. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international hub — approximately 175 miles east. Many Grand Haven travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Grand Haven, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Grand Haven-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Grand Haven, Spring Lake, and Holland offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve Muskegon County from Grand Haven?", a: "Yes. Fast Passport Center serves all of West Michigan including Muskegon County. Our courier service covers Muskegon, Norton Shores, Whitehall, Montague, and all coastal communities from Grand Haven to Manistee. Ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Grand Haven", address: "1106 Robbins Rd, Grand Haven, MI 49417", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Grand Haven", address: " " + "1015 S. Beacon Blvd, Grand Haven, MI 49417", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Grand Haven", address: " " + "1106 Robbins Rd, Grand Haven, MI 49417", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Holland", address: "3035 W. Shore Dr, Holland, MI 49424", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Grand Haven", address: " " + "1105 S. Beacon Blvd, Grand Haven, MI 49417", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Grand Haven, Spring Lake, and central Ottawa County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Holland", address: " " + "12330 James St, Holland, MI 49424", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Holland, Zeeland, and southern Ottawa County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "GRR",
      name: "Gerald R. Ford International Airport",
      distance: "Located in Grand Rapids — approximately 30 miles northeast of Grand Haven",
      address: "5500 44th St SE, Grand Rapids, MI 49512",
      note: "Primary airport for Grand Haven and West Michigan. Growing domestic and international service. Southwest, Delta, American, United, and Allegiant service. International flights to Cancun and Toronto available seasonally. Most Grand Haven international travelers connect through DTW or Chicago O'Hare.",
      flightUrl: "https://www.grr.org/",
      flightLabel: "GRR Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 175 miles east of Grand Haven via I-96",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for West Michigan. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Grand Haven international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};